import React from 'react';
import './style.css';

export default function Searchrecom(props) {
    return (
        <a href={`/search/${props.categorie}/${props.id}`}>
            <div className="search-recom">
                <p>{props.name}</p>
            </div>
        </a>
    )
}